import * as I from '@/interfaces';

export enum WeekMaskFlags {
  Sunday = 128,
  Monday = 64,
  Tuesday = 32,
  Wednesday = 16,
  Thursday = 8,
  Friday = 4,
  Saturday = 2,
  Holiday = 1
}

export enum WeekFlags {
  Sunday,
  Monday,
  Tuesday,
  Wednesday,
  Thursday,
  Friday,
  Saturday,
  Holiday
}

export interface ScheduleDataEx extends I.ScheduleData {
  sunday: boolean;
  monday: boolean;
  tuesday: boolean;
  wednesday: boolean;
  thursday: boolean;
  friday: boolean;
  saturday: boolean;
  holiday: boolean;
}
